import { instrumenter } from '~/app/utils/instrumentation'
import { useEffect } from 'react'

const debounceImagesLoaded = (timeout = 2000): (() => void) => {
  let timer: NodeJS.Timeout | undefined

  return (): void => {
    if (!timer) {
      timer = setTimeout(() => {
        timer = undefined
        instrumenter.recordImagesLoaded()
      }, timeout)
    }
  }
}

const debouncedRecordImagesLoaded = debounceImagesLoaded()

// perfObserver only works client side
// Use in a useEffect or after checking if window is defined
const perfObserver =
  () =>
  (list: PerformanceObserverEntryList): void => {
    list.getEntries().forEach((entry) => {
      if (entry.name.includes('rendering')) {
        if (!window.imageResources) {
          window.imageResources = []
        }
        // each image gets an entry and its load time is processed in instrumenter.recordImagesLoaded
        window.imageResources.push(entry as PerformanceResourceTiming)
        debouncedRecordImagesLoaded()
      }
    })
  }

export const ImageLoadedInstrumenter = (): null => {
  useEffect(() => {
    if (!window.imageResources) {
      window.imageResources = []
    }

    window.windowObserver?.disconnect()
    window.windowObserver = new PerformanceObserver(perfObserver())
    // observe network resouce loading (specifically rendering urls)
    window.windowObserver.observe({ type: 'resource' })
  }, [])

  useEffect(() => {
    if (!window.imageResources) {
      window.imageResources = []
    }

    // run this once when the page loads, assuming we have loaded all of the initial images
    instrumenter.recordImagesLoaded()
  }, [])

  return null
}
